import PersonalityTwo from "./personality-two";

export default PersonalityTwo;
